import { AccountType } from '../../constants/constants';

export function isEnterpriseOrProOrTrial(accountType?: AccountType | string) {
    return accountType && (
        accountType === AccountType.Enterprise
        || accountType === AccountType.Pro
        || accountType === AccountType.ProTrial
        || accountType === AccountType.Trial);
}

export function getFriendlyAccountTypeName(accountType: AccountType | string) {
    switch (accountType) {
        case AccountType.Free: return 'free';
        case AccountType.Community: return 'community';
        case AccountType.ProTrial: return 'pro trial';
        default: return '';
    }
}
